import { sanitizeSankey } from './sankeySanitizer';

// 医疗、科普模块共用：节点从清洗后的连线自动提取，接口只需保证 links 可用。
// 接口连线成环时 ECharts 会直接抛 "Sankey is a DAG, the original data has cycle!"（整图空白），
// 因此先合并重边、剔除自环、破除双向环再渲染；清洗明细在开发环境提示，便于反馈后端修数据。
export function buildSankeyOption(sankey) {
    const { nodes, links, mergedCount, selfLoopCount, cycleCount, invalidCount } = sanitizeSankey(sankey);
    if (process.env.NODE_ENV !== 'production' && (mergedCount || selfLoopCount || cycleCount || invalidCount)) {
        console.warn(
            `[sankey] 已清洗连线避免渲染中断：合并重复连线 ${mergedCount} 条、剔除自环 ${selfLoopCount} 条、跳过成环连线 ${cycleCount} 条、丢弃端点无效 ${invalidCount} 条，请核查接口数据。`
        );
    }
    return {
        tooltip: { trigger: 'item' },
        series: [
            {
                type: 'sankey',
                emphasis: { focus: 'adjacency' },
                data: nodes,
                links,
                nodeAlign: 'justify',
                // 小权重节点仍保留足够间距，避免节点高度趋近 0 时标签重叠。
                nodeGap: 24,
                top: 20,
                bottom: 20,
                // 为最右侧名称留出空间，超长名称可悬浮查看完整内容。
                right: 200,
                lineStyle: {
                    color: 'gradient',
                    curveness: 0.5,
                    opacity: 0.45,
                },
                itemStyle: {
                    borderWidth: 0,
                },
                label: {
                    color: '#333',
                    fontSize: 12,
                    lineHeight: 18,
                    width: 180,
                    overflow: 'truncate',
                },
                levels: [
                    // {
                    //     depth: 0,
                    //     itemStyle: { color: '#ea580c' },
                    // },
                    // {
                    //     depth: 1,
                    //     itemStyle: { color: '#6B9FFF' },
                    // },
                    // {
                    //     depth: 2,
                    //     itemStyle: { color: '#f97316' },
                    // },
                ],
            },
        ],
    };
}
